/**
 * Helpers for building the `filter` query string sent to
 * GET /api/v1/copilot (ListCopilotConversation).
 *
 * The filter grammar is pipe-delimited "[field]=value" clauses. Values are
 * split on commas into an $in clause, so a raw user-typed search term
 * containing "," "|" "[" or "]" would corrupt the query.
 */

const FILTER_GRAMMAR_CHARS = /[,|[\]]/g;

/** Strips characters that would corrupt the filter grammar. */
export const sanitizeSearchTerm = (term) =>
  (term || "").replace(FILTER_GRAMMAR_CHARS, "").trim();

/**
 * Builds the conversation list filter.
 *
 * Always excludes empty conversations (length 0) so that conversations created
 * by a stray "New Chat" click never appear in history.
 */
export const buildConversationFilter = (searchTerm) => {
  const clauses = ["[length]=>0"];

  const term = sanitizeSearchTerm(searchTerm);
  if (term) {
    clauses.push(`[name]=*${term}*`);
  }

  return clauses.join("|");
};
